export default [
  {
    width: 33,
    header: {
      type: 'text',
      caption: 'ID',
    },
    cell: {
      type: 'text',
      value: (e) => e.Id,
    },
  },
  {
    width: 33,
    header: {
      type: 'text',
      caption: 'Lead ID',
    },
    cell: {
      type: 'text',
      value: (e) => e.LeadId,
    },
  },
  {
    width: 33,
    header: {
      type: 'text',
      caption: 'Amount',
    },
    cell: {
      type: 'slot',
      name: 'amount',
    },
  },
];
